module.exports = __webpack_public_path__ + "img/lowAltitude1.1523431d.jpg";